import React from "react";
import { Bar } from "./NpdShared";
import { countByStatus, late, stg } from "./npdUtils";

const Reports = ({ app }) => {
  const { buyers, parts, today } = app;
  // Buyers from the org user table, plus anyone still holding parts (e.g. since disabled)
  const people = [...buyers.map((b) => ({ id: b.orgUserId, name: b.name }))];
  parts.forEach((p) => {
    if (p.buyerId && !people.some((x) => x.id === p.buyerId)) people.push({ id: p.buyerId, name: p.buyerName });
  });
  const rows = people
    .map((e) => {
      const m = parts.filter((p) => p.buyerId === e.id);
      return { e, n: m.length, c: countByStatus(m), late: m.filter((p) => late(p, today) > 0).length };
    })
    .sort((a, b) => b.c[3] / (b.n || 1) - a.c[3] / (a.n || 1));
  const m = {};
  parts.filter((p) => p.s === 3).forEach((p) => {
    const k = `${p.L.name} · ${stg(p)}`;
    m[k] = (m[k] || 0) + 1;
  });
  const st = Object.entries(m).sort((a, b) => b[1] - a[1]).slice(0, 8);

  return (
    <>
      <h2>Reports</h2>
      <p className="sub">Where the team is falling behind</p>
      <div className="panel">
        <h3>Buyer workload</h3>
        <div className="wrap">
          {rows.length ? (
            <table>
              <thead>
                <tr>
                  <th>Buyer</th><th>Parts</th><th>In progress</th><th>Review</th><th>Delayed</th>
                  <th>Completed</th><th>Past target</th><th style={{ width: 180 }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.e.id}>
                    <td>{r.e.name}</td><td>{r.n}</td><td>{r.c[0]}</td><td>{r.c[2]}</td>
                    <td className={r.c[3] ? "red" : ""}>{r.c[3]}</td><td>{r.c[1]}</td><td>{r.late}</td>
                    <td><Bar counts={r.c} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <div className="empty">No buyers found. Create users with the Buyer role first.</div>}
        </div>
      </div>
      <div className="panel">
        <h3>Stage bottlenecks: delayed parts by stage</h3>
        {st.length ? (
          <div className="wrap">
            <table>
              <thead><tr><th>Line and stage</th><th>Delayed parts</th></tr></thead>
              <tbody>
                {st.map((x) => <tr key={x[0]}><td>{x[0]}</td><td className="red">{x[1]}</td></tr>)}
              </tbody>
            </table>
          </div>
        ) : <div className="empty">No delayed parts right now.</div>}
      </div>
    </>
  );
};

export default Reports;
